module.exports = __webpack_public_path__ + "img/expense.c88f730f.svg";